<template>
  <div class="list" name="info">
    <el-card style="margin-bottom:20px" shadow="never">
      <el-row>
        <el-form label-width="100px" :model="baseInfo" :rules="rule_data" ref="baseInfo" >
          <h3 size="medium">基本信息</h3>
          <el-form-item label="登录账号" prop="fAgentAccount">
            <el-input v-model="baseInfo.fAgentAccount" style="width: 30%" placeholder="8~20位数字或字母" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="代理商名称" prop="fTitle">
            <el-input v-model="baseInfo.fTitle" style="width: 30%" placeholder="请输入代理商名称" :disabled="dialogDisabled"></el-input>
          </el-form-item>
          <el-form-item label="绑定手机" prop="fMobile">
            <el-input v-model="baseInfo.fMobile" style="width: 30%" placeholder="选填，建议输入" :disabled="dialogDisabled"></el-input >
          </el-form-item>
        </el-form>
        <h3 size="medium" >成本信息</h3>
        <el-form ref="pos" label-width="100px" :inline="true" >
          <el-form-item label="分成比例" size="large" label-width="50px;" v-show="ruleType === 0">
            <el-input type="text" v-model="baseInfo.fLowerDivideCent" class="FLowerDivideCent" :disabled="dialogDisabled"><template slot="append">%</template></el-input>
          </el-form-item>
          <el-form-item label="刷卡成本" size="large" label-width="50px;" v-show="ruleType === 1">
            <!--<el-button type="primary" :inline="true" @click="setDefaultRate"  plain :disabled = dialogDisabled>使用默认成本</el-button>-->
          </el-form-item>
          <div class="" v-loading="saleLoading" v-show="ruleType === 1">
            <el-table :data="cardTable" border size="small" align="center" style="width:900px;" :span-method="editTemplateTableSpanMethod">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1" :disabled="dialogDisabled"/><span>%</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Max" label="D+1封顶手续费" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1Max" v-if="scope.row.d1Max !== '--'" :disabled="dialogDisabled"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0" label="D+0费率" width="150" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d0 !== '--'">
                    <input :class="scope.row.d0" :disabled="dialogDisabled"/>
                    <span slot="suffix">%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Fixed" label="D+0单笔手续费" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d0Fixed" v-if="scope.row.d0Fixed !== '--'" :disabled="dialogDisabled"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d0Fixed" label="额外收取下级分成比例" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.posLower" :disabled="dialogDisabled"/>
                  <span>%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item label="扫码成本" size="large" label-width="50px;" v-show="ruleType === 1"></el-form-item>
          <div class="qr agentMsgForm" v-loading="saleLoading" v-show="ruleType === 1">
            <div style="margin-top: -10px">
              <el-form-item label="额外收取下级分成比例" size="large" label-width="50px;">
                <div>
                  <input class="scanLowerDivideCent" :disabled="dialogDisabled" @blur="onRateBlur('scanLowerDivideCent')" style="width: 200px"/>
                  <span style="float: right;height: 40px;line-height: 40px;">%</span>
                </div>
              </el-form-item>
            </div>
            <el-table :data="scanWechatTable" border size="small" align="center" style="width:720px;">
              <el-table-column prop="type" label="微信费用" align="center">
                <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1 !== '--'">
                      <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)" :disabled="dialogDisabled"/>
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-collapse v-model="showWechat" style="width:720px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="多通道费率" name="1">
                <el-table :data="scanWechatMulti" border size="small" align="center" style="width:720px;">
                  <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1L" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)">
                        <input
                          :class="scope.row.typeLetterL + '_' + scope.row.d1L"
                          :disabled="dialogDisabled || defaultDataParam.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''"
                          @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterL + '.' + scope.row.d1L)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1R" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)">
                        <input
                          :class="scope.row.typeLetterR + '_' + scope.row.d1R"
                          :disabled="dialogDisabled || defaultDataParam.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''"
                          @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterR + '.' + scope.row.d1R)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="showRihua" style="width:360px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="服饰日化费率" name="1">
                <el-row class="row">
                  <el-col class="item">费用类型</el-col>
                  <el-col class="item">D+1费率</el-col>
                </el-row>
                <el-row class="row">
                  <el-col class="item">服饰日化-借记卡</el-col>
                  <el-col class="item">
                    <el-input v-model="rihuaEntity.wxCategoryDebitCommissionD1" disabled>
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row  class="row">
                  <el-col class="item">服饰日化-贷记卡</el-col>
                  <el-col class="item">
                    <el-input v-model="rihuaEntity.wxCategoryCreditCommissionD1" disabled>
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
            <el-table :data="scanAlipayTable" border size="small" align="center" style="width:720px;">
              <el-table-column prop="type" label="支付宝费率" align="center">
                <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.d1 !== '--'">
                      <input :class="scope.row.d1" @blur="onRateBlur(scope.row.d1)" :disabled="dialogDisabled"/>
                      <span>%</span>
                    </div>
                    <span v-else>——</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-collapse v-model="showAlipay" style="width:720px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="多通道费率" name="1">
                <el-table :data="scanAlipayMulti" border size="small" align="center" style="width:720px;">
                  <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1L" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.d1L)">
                        <input :class="scope.row.typeLetterL + '_' + scope.row.d1L" :disabled="dialogDisabled || defaultDataParam.extraFeeRate[scope.row.typeLetterL][scope.row.d1L] === ''"
                          @blur="onRateBlur(scope.row.typeLetterL === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterL + '.' + scope.row.d1L)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1R" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.d1R)">
                        <input :class="scope.row.typeLetterR + '_' + scope.row.d1R" :disabled="dialogDisabled || defaultDataParam.extraFeeRate[scope.row.typeLetterR][scope.row.d1R] === ''"
                          @blur="onRateBlur(scope.row.typeLetterR === 'wechat'
                            ? 't1WeixinCommission'
                            : 't1AlipayCommission', scope.row.typeLetterR + '.' + scope.row.d1R)" />
                        <span>%</span>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
          <el-form-item label="银联二维码" size="large" label-width="50px;" v-show="ruleType === 1"></el-form-item>
          <div class="" v-loading="saleLoading" v-show="ruleType === 1">
            <el-table :data="unionpayTable" border size="small" align="center" style="width:800px;" :span-method="editTemplateTableSpanMethod">
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="d1" label="D+1费率>1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1 !== '--'">
                    <input :class="scope.row.d1" :disabled="dialogDisabled"/>
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Max" label="D+1封顶手续费" width="180" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.d1Max" v-if="scope.row.d1Max !== '--'" :disabled="dialogDisabled"/>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="d1Level2" label="D+1费率≤1000元" width="180" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.d1Level2 !== '--'">
                    <input :class="scope.row.d1Level2" :disabled="dialogDisabled"/>
                    <span>%</span>
                  </div>
                  <span v-else>——</span>
                </template>
              </el-table-column>
              <el-table-column prop="posLower" label="额外收取下级分成比例" width="150" align="center">
                <template slot-scope="scope">
                  <input :class="scope.row.posLower" :disabled="dialogDisabled"/>
                  <span>%</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <h3 size="medium">结算信息（非单独入账可不填）</h3>
        <el-form label-width="100px" :inline="true" >
          <el-form-item label="账户类型" prop="FBankAccountType">
            <el-select v-model="baseInfo.fBankAccountType" style="width: 120px;" placeholder="" clearable :disabled="dialogDisabled">
              <el-option label="个人" value="1"></el-option>
              <el-option label="公司" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户名" prop="fBankAccount">
            <el-input v-model="baseInfo.fBankAccount" :disabled="dialogDisabled"></el-input>
          </el-form-item>
          <el-form-item label="开户人身份证" prop="fIdentityCard">
            <el-input v-model="baseInfo.fIdentityCard" :disabled="dialogDisabled"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="fBankCardid">
            <el-input v-model="baseInfo.fBankCardid" :disabled="dialogDisabled"></el-input>
          </el-form-item>
          <el-form-item label="开户行" >
            <el-select style="width:150px;" placeholder="" clearable filterable
              v-model="baseInfo.fBankType"
              @change="setBankName"
              prop="fBankType"
              :disabled="dialogDisabled">
              <el-option v-for="item in bank_list" :key="item.F_bank_name_code" :label="item.F_bank_name" :value="item.F_bank_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行网点" >
            <el-select
              style="width:120px;"
              placeholder="请选择省"
              clearable
              filterable
              v-model="baseInfo.fBankArea"
              @change="setBankPro"
              prop="fBankArea"
              :disabled="dialogDisabled">
              <el-option v-for="item in pro_list" :key="item.F_bank_area_code" :label="item.F_bank_area" :value="item.F_bank_area"></el-option>
            </el-select>
            <el-select
              v-model="baseInfo.fBankCity"
              placeholder="请选择市"
              @change="setBankCity"
              clearable
              style="width: 120px;"
              prop="fBankCity"
              :disabled="dialogDisabled">
              <el-option v-for="item in city_list" :key="item.F_bank_city_code" :label="item.F_bank_city" :value="item.F_bank_city">
              </el-option>
            </el-select>
            <el-select
              v-model="baseInfo.fBankPoint"
              placeholder="分行网点"
              @change="setBranch"
              clearable
              style="width: 120px;"
              prop="fBankPoint"
              :disabled="dialogDisabled">
              <el-option v-for="item in branch_list" :key="item.F_branch_no" :label="item.F_branch_name" :value="item.F_branch_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预留手机号" prop="fMobile">
            <el-input v-model="baseInfo.fBankMobile" :disabled="dialogDisabled"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { hideBankCardNum, hideRealName, hidePhoneNum, hideIdCardNum } from '@/utils/hideSensitiveInfo.js'
// export default {InfoJs};
import qs from 'qs'
import { getSalesmanGroup, subAgentDetail, subAgentList, getAgFee } from '@/api/partner'
export default {
  name: 'Info',
  data () {
    return {
      subAg_list: [],
      domain: 'https://baseweb.lszzg.com/',
      bank_list: [],
      pro_list: [],
      city_list: [],
      branch_list: [],
      data: [],
      t1DebitCommission: '',
      tableData1: [],
      dataParam: {},
      defaultDataParam: {},
      agent_level_list: [],
      agentId: '',
      checkLoading: false,
      addLoading: false,
      seloading: false,
      saleLoading: false,
      editSaleLoading: false,
      table_type: 'sale',
      form_type: 'sale',
      salesNum: '',
      search_group_list: [],
      comeTime: '',
      operator: '编辑',
      downCtr: true,
      dialogDisabled: true,
      totaldata: {},
      editSaleForm: {},
      roleName: '',
      // 搜索表单信息
      search_subAg: {
        startTime: '',
        endTime: '',
        FCreateTime: '',
        FAgentId: '',
        FName: '',
        FBlockStatus: '',
        pageNo: '',
        pageSize: '',
        totalCount: '',
        FAgentLevel: '',
        FOperator: ''
      },
      viewAgent: {
        show: false
      },
      dialogFormVisible: false,
      rule_data: {
        FAgentAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入登录账号'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入8-20位数字或字母'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FAgentPassword: [{
          validator: (rule, value, callback) => {
            if (/^[a-zA-Z0-9]+$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入正确的密码格式'))
            }
          }
        }],
        fName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fTitle: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入代理商姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          }
        }],
        FBankAccountType: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择账户类型'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入开户名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FIdentityCard: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号码'))
            } else {
              if (!(/^\d{17}(\d|\w){1}$/.test(value))) {
                callback(new Error('身份证号码输入有误'))
              } else {
                callback()
              }
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankCardid: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入银行卡号'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankType: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入开户行'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankArea: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入省名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankCity: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入市名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankPoint: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入区名'))
            }
          },
          required: false,
          trigger: 'blur'
        }],
        FBankMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value))) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: false,
          trigger: 'blur'
        }]
      },
      groupIdDisabledInput: false,
      disabledInput: false,
      // 弹框信息
      addSale: {
        show: false,
        flag: false
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      props: {
        label: 'name',
        value: 'name',
        children: 'children'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 新增界面数据
      editForm: {
        FAgentAccount: '',
        FAgentPassword: '',
        FName: '',
        FTitle: '',
        FMobile: '',
        FBankAccountType: '',
        FBankAccount: '',
        FIdentityCard: '',
        FBankCardid: '',
        FBankType: '',
        FBankArea: '',
        FBankCity: '',
        FBankPoint: '',
        FBankMobile: '',
        insertFlag: '1', // 新建
        t1DebitCommission: '',
        t1DebitMaxFee: '',
        t0DebitCommission: '',
        t1CreditCommission: '',
        t0CreditCommission: '',
        t1OverSeasCommission: '',
        t0OverSeasCommission: '',
        t0FixFee: '',
        posLowerDivideCent: '',
        t1WeixinCommission: '',
        t0WeixinCommission: '',
        t1AlipayCommission: '',
        t0AlipayCommission: '',
        t1UnionpayDebitRate: '',
        t0UnionpayDebitRate: '',
        t1UnionpayCreditRate: '',
        t0UnionpayCreditRate: '',
        t1UnionpayOverseasRate: '',
        t0UnionpayOverseasRate: '',
        unionLowerDivideCent: '',
        scanLowerDivideCent: '',
        FLowerDivideCent: ''
      },
      baseInfo: {
        fBankAccountType: '',
        fBankAccount: '',
        fIdentityCard: '',
        fBankCardid: '',
        fBankType: '',
        fBankArea: '',
        fBankCity: '',
        fBankPoint: '',
        fBankMobile: ''
      },
      pos: {
        t1DebitCommission: '',
        t1CreditCommission: '',
        t1OverSeasCommission: '',
        t1DebitMaxFee: '',
        t0DebitCommission: '',
        t0CreditCommission: '',
        t0OverSeasCommission: '',
        t0FixFee: '',
        lowerDivideCent: ''
      },
      scan: {
        t1WeixinCommission: '',
        t1AlipayCommission: '',
        t0WeixinCommission: '',
        t0AlipayCommission: '',
        t1WeixinCommissionByMillion: '',
        t1AlipayCommissionByMillion: '',
        t0WeixinCommissionByMillion: '',
        t0AlipayCommissionByMillion: '',
        scanLowerDivideCent: ''
      },
      unionpay: {
        t1UnionpayDebitRate: '',
        t0UnionpayDebitRate: '',
        t1UnionpayCreditRate: '',
        t0UnionpayCreditRate: '',
        t1UnionpayOverseasRate: '',
        t0UnionpayOverseasRate: '',
        unionLowerDivideCent: ''
      },
      ruleType: '', // 分成规则：0:成本规则，1：成本和高签比例规则
      fRate: '',
      // addForm : {}
      cardTable: [
        {
          type: '借记卡',
          d1: 't1DebitCommission',
          d1Max: 't1DebitMaxFee',
          d0: 't0DebitCommission',
          d0Fixed: 't0FixFee',
          posLower: 'posLowerDivideCent'
        },
        {
          type: '贷记卡',
          d1: 't1CreditCommission',
          d1Max: '--',
          d0: 't0CreditCommission',
          d0Fixed: '--'
        },
        {
          type: '境外卡',
          d1: 't1OverSeasCommission',
          d1Max: '--',
          d0: 't0OverSeasCommission',
          d0Fixed: '--'
        }
      ],
      scanWechatTable: [
        {
          extraType: '线下（默认）',
          d1: 't1WeixinCommission',
          posLower: 'scanLowerDivideCent'
        }
      ],
      showWechat: [],
      showRihua: [],
      rihuaEntity: {
        wxCategoryDebitCommissionD1: '', // 服饰日化-借记卡
        wxCategoryCreditCommissionD1: '' // 服饰日化-贷记卡
      },
      scanWechatMulti: [
        {
          extraTypeL: '绿洲',
          d1L: 'oasis',
          typeLetterL: 'wechat',
          extraTypeR: '公益',
          d1R: 'publicWeal',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '高校食堂',
          d1L: 'collegeCanteen',
          typeLetterL: 'wechat',
          extraTypeR: '公缴',
          d1R: 'publicPayment',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '私立中小幼',
          d1L: 'privateSchool',
          typeLetterL: 'wechat',
          extraTypeR: '保险',
          d1R: 'insurance',
          typeLetterR: 'wechat'
        },
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'wechat',
          extraTypeR: '——',
          d1R: '--',
          typeLetterR: 'wechat'
        }
      ],
      scanAlipayTable: [
        {
          d1: 't1AlipayCommission',
          extraType: '线下（默认）'
        }
      ],
      showAlipay: [],
      scanAlipayMulti: [
        {
          extraTypeL: '线上',
          d1L: 'online',
          typeLetterL: 'alipay',
          extraTypeR: '蓝海活动',
          d1R: 'bluesea',
          typeLetterR: 'alipay'
        },
        {
          extraTypeL: '行业活动0',
          d1L: 'activityFee0',
          typeLetterL: 'alipay',
          extraTypeR: '行业活动1',
          d1R: 'activityFee1',
          typeLetterR: 'alipay'
        }
      ],
      unionpayTable: [
        {
          type: '借记卡',
          d1: 'fT1DebitCommissionBymillion',
          d1Max: 'fT1UnionpayDebitMaxCharge',
          d1Level2: 'fT1BelowDebitCommissionBymillion',
          posLower: 'unionLowerDivideCent'
        },
        {
          type: '贷记卡',
          d1: 'fT1CreditCommissionBymillion',
          d1Max: '--',
          d1Level2: 'fT1BelowCreditCommissionBymillion'
        }
      ],
      extraFeeRate: {
        alipay: {
          activityFee0: '', // 活动0
          activityFee1: '', // 活动1
          bluesea: '', // 蓝海
          online: ''// 线上
        },
        wechat: {
          collegeCanteen: '', // 高校食堂
          insurance: '', // 保险
          oasis: '', // 绿洲
          online: '', // 线上
          privateSchool: '', // 私立学校
          publicPayment: '', // 公缴
          publicWeal: ''// 公益
        }
      }
    }
  },
  methods: {
    getUserInfo () {
      this.roleName = this.$store.getters.roleName
    },
    deleteValid (v) {
      if (v) {
        if (this.table_type === 'sale') {
          this.$refs.addSaleForm.validateField('masterChannelId')
        } else {
          this.$refs.addStaffForm.validateField('masterChannelId')
        }
      }
    },
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_subAg.startTime = value[0]
        this.search_subAg.endTime = value[1]
      } else {
        this.search_subAg.startTime = ''
        this.search_subAg.endTime = ''
      }
    },
    changeVCity (item) {
      this.edit_group_list = []
      // this.editSaleForm.f_group_id = '';
      if (!this.editSaleForm.f_city_code) {
        return
      }
      this.getGroup(this.editSaleForm.f_city_code, 'edit')
    },
    changeCity () {
      this.add_group_list = []
      this.addSaleForm.f_group_id = ''
      if (!this.addSaleForm.f_city_code) {
        return
      }
      this.getGroup(this.addSaleForm.f_city_code, 'add')
    },
    handleClick () {
      this.getList()
    },
    transferType (index, row) {
      this.$confirm('转职成功后将不可修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dynamicTags.splice(this.dynamicTags.indexOf('tag'), 1)
        this.$message({
          type: 'success',
          message: '转职成功!'
        })
      })
    },
    tableSortChange1 (val) {
      if (val.prop !== null) {
        if (val.order === 'descending') {
          this.search_subAg.orderColumn = val.prop
          this.search_subAg.orderType = 1
        } else {
          this.search_subAg.orderColumn = val.prop
          this.search_subAg.orderType = 0
        }
      }
      this.getList()
    },
    closeViewDialog () {
      // this.$refs['addForm'].resetFields();
    },
    closeDialog () {
      // this.$refs['addStaffForm'].resetFields();
    },
    showAddSale () {
      // this.$refs.addSaleForm.resetFields();
    },
    handleChange (value) {
      this.getFBankAreaPrvince(value)
    },
    setBankName (value) {
      if (this.addStaff.show && !this.addStaff.flag) {
        this.addStaffForm.f_bank_address = ''
        // this.addStaff.flag = false;
      } else if (this.viewStaff.show && !this.viewStaff.flag) {
        this.editStaffForm.f_bank_address = ''
        // this.viewStaff.flag = false;
      }
      let obj = {}
      obj = this.bank_list.find((item) => {
        return item.F_bank_name === value
      })
      if (this.addStaff.show && obj) {
        this.addStaffForm.f_bank_code = obj.F_bank_name_code
        if (this.addStaffForm.f_bank_code && this.addStaffForm.f_bank_city_code) {
          this.getBranchList()
        }
      } else if (this.viewStaff.show && obj) {
        this.editStaffForm.f_bank_code = obj.F_bank_name_code
        if (this.editStaffForm.f_bank_code && this.editStaffForm.f_bank_city_code) {
          this.getBranchList()
        }
      }
      this.addStaff.flag = false
      this.viewStaff.flag = false
    },

    initRouters () {
      // this.$router.push("/saleManager/sales");
      var routes = this.$router.options.routes
      for (var i = 0; i < routes.length; i++) {
        if (routes[i].hidden !== true && routes[i].children && routes[i].children.length) {
          var tempObj = {}
          var module = routes[i]
          var menus = module.children
          tempObj.name = module.name
          tempObj.path = module.path
          tempObj.access = module.path
          tempObj.children = []
          var menuLen = menus.length
          for (var j = 0; j < menuLen; j++) {
            if (menus[j].hidden !== true && menus[j].children && menus[j].children.length) {
              var tempChildObj = {}
              var menu = menus[j]
              var pages = menu.children
              tempChildObj.name = menu.name
              tempChildObj.path = '/' + menu.path
              tempChildObj.access = tempObj.path + '/' + menu.path
              tempChildObj.children = []
              var pagesLen = pages.length
              for (var k = 0; k < pagesLen; k++) {
                if (pages[k].hidden !== true) {
                  var tempPageObj = {}
                  var page = pages[k]
                  tempPageObj.name = page.name
                  tempPageObj.path = '/' + page.path
                  tempPageObj.access = tempObj.path + '/' + menu.path + '/' + page.path
                  tempChildObj.children.push(tempPageObj)
                }
              }
              tempObj.children.push(tempChildObj)
            }
          }
          this.accesss.push(tempObj)
        }
      }
    },
    toQueryPair (key, value) {
      if (typeof value === 'undefined') {
        return key
      }
      return key + '=' + encodeURIComponent(value === null ? '' : String(value))
    },
    toQueryString (obj) {
      var ret = []
      var that = this
      for (var key in obj) {
        key = encodeURIComponent(key)
        var values = obj[key]
        if (values && values.constructor === Array) { // 数组
          var queryValues = []
          for (var i = 0, len = values.length, value; i < len; i++) {
            value = values[i]
            queryValues.push(that.toQueryPair(key, value))
          }
          ret = ret.concat(queryValues)
        } else { // 字符串
          ret.push(that.toQueryPair(key, values))
        }
      }
      return ret.join('&')
    },
    /**
       * 点击搜索按钮事件
       */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_subAg.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
       * 改变页码和当前页时需要拼装的路径方法
       * @param {string} field 参数字段名
       * @param {string} value 参数字段值
       */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      query[field] = value

      this.$router.push({
        path: path,
        query: query
      })
    },
    formatStatus (item) {
      return item.fBlockStatus === 0 ? '正常' : (item.fBlockStatus === 1 ? '冻结' : '注销')
    },
    formatLevel (item) {
      return item.fAgentLevel === 1 ? '一代' : (item.fAgentLevel === 2 ? '二代' : (item.fAgentLevel === 3 ? '三代' : (item.fAgentLevel === 4 ? '四代' : (item.fAgentLevel === 5 ? '五代' : '六代'))))
    },
    formatType (item) {
      return item.fBankAccountType === 1 ? '个人' : '公司'
    },

    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      // this.setPath('pageNum', page);
      var totalCount = this.salesNum
      var pageSize = this.paginations.pageSize
      this.search_subAg.pageNo = page
      this.search_subAg.pageSize = pageSize
      this.search_subAg.Count = totalCount
      // this.search_subAg.pageSize = size;
      this.getList()
    },

    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.salesNum
      var pageNo = this.paginations.pageNum
      this.search_subAg.pageSize = size
      this.search_subAg.pageNo = pageNo
      this.search_subAg.Count = totalCount
      this.onSearch()
    },
    getGroup (id, type) {
      getSalesmanGroup({
        f_city_code: id
      }, (data) => {
        if (parseInt(data.code) !== 0) {
        } else {
          if (type === 'search') {
            this.search_group_list = data.data
          } else if (type === 'add') {
            this.add_group_list = data.data
          } else {
            this.edit_group_list = data.data
          }
        }
      })
    },

    // 获取编辑业务员信息
    getRow () {
      var id = this.$store.getters.userId
      var data = {
        FAgentId: id
      }
      var that = this

      data = qs.stringify(data)
      subAgentDetail(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else if (parseInt(data.error_code) === 0) {
          that.fRate = data.FRate / 100
          that.baseInfo = data.baseInfo
          var baseInfo = that.baseInfo
          that.pos = data.pos
          that.scan = data.scan
          that.unionpay = data.unionpay
          that.ruleType = data.ruleType
          that.baseInfo.fAgentPassword = ''
          var bankType = that.baseInfo.fBankAccountType;

          (baseInfo.fBankAccount === '' && baseInfo.fBankAccount === '') ? (that.baseInfo.fBankAccountType = '')
            : ((bankType === 1) ? (that.baseInfo.fBankAccountType = '个人') : (that.baseInfo.fBankAccountType = '公司'))

          baseInfo.realfMobile = baseInfo.fMobile
          baseInfo.realfBankAccount = baseInfo.fBankAccount
          baseInfo.realfIdentityCard = baseInfo.fIdentityCard
          baseInfo.realfBankCardid = baseInfo.fBankCardid
          baseInfo.fMobile = hidePhoneNum(baseInfo.fMobile)
          baseInfo.fBankAccount = hideRealName(baseInfo.fBankAccount)
          baseInfo.fIdentityCard = hideIdCardNum(baseInfo.fIdentityCard)
          baseInfo.fBankCardid = hideBankCardNum(baseInfo.fBankCardid)

          this.setRate()
        }
      })
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * 获取用户信息列表方法
       */
    getList () {
      this.saleLoading = true
      var levelName = this.search_subAg.FAgentLevel
      var level;
      (levelName === '一代' ? level = 1 : (levelName === '二代' ? level = 2 : (levelName === '三代' ? level = 3
        : (levelName === '四代' ? level = 4 : (levelName === '五代' ? level = 5 : (levelName === '六代' ? level = 6 : level = ''))))))
      this.search_subAg.FAgentLevel = level
      var data = this.formatSearch(this.search_subAg)
      this.search_subAg.FAgentLevel = levelName
      data = qs.stringify(data)
      subAgentList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          this.saleLoading = false
          this.paginations.total = data.totalCount
          this.subAg_list = data.list

          this.salesNum = data.totalCount
        }
      })
    },
    formatTotalAmount (item) {
      return this.fmoney(item.f_merchant_total_amount / 100, 2)
    },
    formatTotalIncome (item) {
      return this.fmoney(item.f_total_income / 100, 2)
    },
    fmoney (s, n) {
      if (n) {
        n = n > 0 && n <= 20 ? n : 2
      } else {
        n = 0
      }
      // eslint-disable-next-line no-useless-escape
      s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
      var l = s.split('.')[0].split('').reverse()
      var r = s.split('.')[1]
      var t = ''
      for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
      }
      if (r) {
        return t.split('').reverse().join('') + '.' + r
      } else {
        return t.split('').reverse().join('')
      }
    },
    // 获取银行列表
    getBank () {
      var that = this
      this.$jquery.ajax({
        type: 'POST',
        asyn: false,
        url: that.domain + 'leposweb/home/getbanknamecode.do',
        contentType: 'application/json; charset=utf-8',
        dataType: 'jsonp',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.bank_list = eval(json.list)
        }
      })
    },
    // 获取省列表
    getPro () {
      var that = this
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        url: that.domain + 'leposweb/home/getbankareacode.do',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.pro_list = eval(json.list)
        }
      })
    },
    // 获取市列表
    getCity () {
      var that = this
      var bankAreaCode = this.baseInfo.FBankAreaCode
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        data: { bankAreaCode: bankAreaCode },
        url: that.domain + 'leposweb/home/getbankcitycode.do?',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.city_list = eval(json.list)
        }
      })
    },

    // 设置省
    setBankPro (value) {
      let obj = {}
      obj = this.pro_list.find((item) => {
        return item.F_bank_area === value
      })
      this.baseInfo.FBankArea = value
      this.baseInfo.FBankAreaCode = obj.F_bank_area_code
      if (this.baseInfo.FBankAreaCode) {
        this.getCity()
      }
      console.log(this.baseInfo)
    },
    // 设置市
    setBankCity (value) {
      let obj = {}
      obj = this.city_list.find((item) => {
        return item.F_bank_city === value
      })
      this.baseInfo.FBankCityCode = obj.F_bank_city_code
      if (this.baseInfo.FBankCityCode) {
        this.getBranchList()
      }
    },
    // 设置网点
    setBranch (value) {

    },
    getBranchList () {
      var that = this
      var bankNo = this.baseInfo.FBankTypeCode
      var cityNo = this.baseInfo.FBankCityCode
      that.seloading = true
      this.$jquery.ajax({
        type: 'POST',
        url: that.domain + 'leposweb/home/getbankbranch2.do',
        data: { bankNo: bankNo, cityNo: cityNo },
        dataType: 'jsonp',
        success: function (json) {
          // eslint-disable-next-line no-eval
          json = eval(json.list)
          if (json.length > 0) {
            that.branch_list = json
            that.seloading = false
          }
        }
      })
    },
    setDefaultRate () {
      this.$jquery('.t1DebitCommission').val(this.defaultDataParam.t1Debit)
      this.$jquery('.t1DebitMaxFee').val(this.defaultDataParam.t1DebitMax)
      this.$jquery('.t1CreditCommission').val(this.defaultDataParam.t1Credit)
      this.$jquery('.t1OverSeasCommission').val(this.defaultDataParam.t1OverSeas)
      this.$jquery('.t1WeixinCommission').val(this.defaultDataParam.t1weixin)
      this.$jquery('.t1AlipayCommission').val(this.defaultDataParam.t1Alipay)
      this.$jquery('.posLowerDivideCent').val(this.defaultDataParam.posLower)

      this.$jquery('.t0DebitCommission').val(this.defaultDataParam.t0Debit)
      this.$jquery('.t0CreditCommission').val(this.defaultDataParam.t0Credit)
      this.$jquery('.t0OverSeasCommission').val(this.defaultDataParam.t0OverSeas)
      this.$jquery('.t0FixFee').val(this.defaultDataParam.t0FixFee)
      this.$jquery('.t0WeixinCommission').val(this.defaultDataParam.t0weixin)
      this.$jquery('.t0AlipayCommission').val(this.defaultDataParam.t0Alipay)
      this.$jquery('.scanLowerDivideCent').val(this.defaultDataParam.scanLower)
      // this.$jquery(".lowerDivideCent").val(lower);

      this.$jquery('.fT1DebitCommissionBymillion').val(this.defaultDataParam.t1UnionDebit)
      this.$jquery('.fT1CreditCommissionBymillion').val(this.defaultDataParam.t1UnionCredit)
      this.$jquery('.fT1OverseasCommissionBymillion').val(this.defaultDataParam.t1UnionOverseas)
      this.$jquery('.fT0DebitCommissionBymillion').val(this.defaultDataParam.t0UnionDebit)
      this.$jquery('.fT0CreditCommissionBymillion').val(this.defaultDataParam.t0UnionCredit)
      this.$jquery('.fT0OverseasCommissionBymillion').val(this.defaultDataParam.t0UnionOverseas)
      this.$jquery('.unionLowerDivideCent').val(this.defaultDataParam.unionLower)
      this.$jquery('.fT1UnionpayDebitMaxCharge').val(this.defaultDataParam.t1UnionpayDebitMaxCharge)

      this.$jquery('.fT1BelowDebitCommissionBymillion').val(this.defaultDataParam.t1BelowUnionDebitRate)
      this.$jquery('.fT0BelowDebitCommissionBymillion').val(this.defaultDataParam.t0BelowUnionDebitRate)
      this.$jquery('.fT1BelowCreditCommissionBymillion').val(this.defaultDataParam.t1BelowUnionCreditRate)
      this.$jquery('.fT0BelowCreditCommissionBymillion').val(this.defaultDataParam.t0BelowUnionCreditRate)

      this.$jquery('.fT1BelowOverseasCommissionBymillion').val(this.defaultDataParam.t1BelowUnionOverseasRate)
      this.$jquery('.fT0BelowOverseasCommissionBymillion').val(this.defaultDataParam.t0BelowUnionOverseasRate)
    },
    /**
       * @deprecated 获取默认费率方法
       */
    getRate () {
      var that = this
      var data = ''
      data = qs.stringify(data)
      getAgFee(data).then(function (data) {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          that.pos = data.pos
          that.scan = data.scan
          that.unionpay = data.unionpay
          that.ruleType = data.ruleType
          var fRate = data.FRate / 100

          if (that.ruleType === 0) {
            // debugger
            // var lowerDivideCent = that.$store.state.user.lowerDivideCent
            //  that.addForm.FLowerDivideCent = lowerDivideCent;
          } else {
            var t1Debit = (that.pos.t1DebitCommission) / 100
            var t1DebitMax = (that.pos.t1DebitMaxFee) / 1000000
            var t1Credit = (that.pos.t1CreditCommission) / 100
            var t1OverSeas = (that.pos.t1OverSeasCommission) / 100
            var t1weixin = (that.scan.t1WeixinCommissionByMillion) / 10000
            var t1Alipay = (that.scan.t1AlipayCommissionByMillion) / 10000
            console.log(t1Alipay)

            var t0Debit = (that.pos.t0DebitCommission) / 100
            var t0Credit = (that.pos.t0CreditCommission) / 100
            var t0OverSeas = (that.pos.t0OverSeasCommission) / 100
            var t0FixFee = (that.pos.t0FixFee) / 1000000
            var t0weixin = (that.scan.t0WeixinCommissionByMillion) / 10000
            var t0Alipay = (that.scan.t0AlipayCommissionByMillion) / 10000

            var t1UnionDebit = (that.unionpay.fT1DebitCommissionBymillion) / 100
            var t1UnionCredit = (that.unionpay.fT1CreditCommissionBymillion) / 100
            var t1UnionOverseas = (that.unionpay.fT1OverseasCommissionBymillion) / 100
            var t0UnionDebit = (that.unionpay.fT0DebitCommissionBymillion) / 100
            var t0UnionCredit = (that.unionpay.fT0CreditCommissionBymillion) / 100
            var t0UnionOverseas = (that.unionpay.fT0OverseasCommissionBymillion) / 100
            var t1UnionpayDebitMaxCharge = that.unionpay.fT1DebitMaxFeeBymillion / 1000000
            var t1BelowUnionCreditRate = that.rounding(Number(t1UnionCredit * fRate))
            var t0BelowUnionCreditRate = that.rounding(Number(t0UnionCredit * fRate))
            var t1BelowUnionDebitRate = that.rounding(Number(t1UnionDebit * fRate))
            var t0BelowUnionDebitRate = that.rounding(Number(t0UnionDebit * fRate))
            var t1BelowUnionOverseasRate = that.rounding(Number(t1UnionOverseas * 1))
            var t0BelowUnionOverseasRate = that.rounding(Number(t0UnionOverseas * 1))

            var posLower = that.pos.lowerDivideCent
            var scanLower = that.scan.lowerDivideCent
            var unionLower = that.unionpay.fLowerDivideCent

            that.defaultDataParam.t1Debit = t1Debit
            that.defaultDataParam.t1DebitMax = t1DebitMax
            that.defaultDataParam.t1Credit = t1Credit
            that.defaultDataParam.t1OverSeas = t1OverSeas
            that.defaultDataParam.t1weixin = t1weixin
            that.defaultDataParam.t1Alipay = t1Alipay

            that.defaultDataParam.t0Debit = t0Debit
            that.defaultDataParam.t0Credit = t0Credit
            that.defaultDataParam.t0OverSeas = t0OverSeas
            that.defaultDataParam.t0FixFee = t0FixFee
            that.defaultDataParam.t0weixin = t0weixin
            that.defaultDataParam.t0Alipay = t0Alipay

            that.defaultDataParam.posLower = posLower
            that.defaultDataParam.scanLower = scanLower
            that.defaultDataParam.unionLower = unionLower

            that.defaultDataParam.t1UnionDebit = t1UnionDebit
            that.defaultDataParam.t0UnionDebit = t0UnionDebit
            that.defaultDataParam.t1UnionCredit = t1UnionCredit
            that.defaultDataParam.t0UnionCredit = t0UnionCredit
            that.defaultDataParam.t1UnionOverseas = t1UnionOverseas
            that.defaultDataParam.t0UnionOverseas = t0UnionOverseas
            that.defaultDataParam.t1UnionpayDebitMaxCharge = t1UnionpayDebitMaxCharge
            that.defaultDataParam.t1BelowUnionCreditRate = t1BelowUnionCreditRate
            that.defaultDataParam.t0BelowUnionCreditRate = t0BelowUnionCreditRate
            that.defaultDataParam.t1BelowUnionDebitRate = t1BelowUnionDebitRate
            that.defaultDataParam.t0BelowUnionDebitRate = t0BelowUnionDebitRate
            that.defaultDataParam.t1BelowUnionOverseasRate = t1BelowUnionOverseasRate
            that.defaultDataParam.t0BelowUnionOverseasRate = t0BelowUnionOverseasRate
            that.defaultDataParam.fRate = fRate
          }
        }
        // 这里做ajax请求
        // 如果数据没有被修改这个回调方法不会执行
      })
    },
    setRate () {
      var that = this
      if (that.ruleType === 0) {
        // var ruleType = that.ruleType
        this.$jquery('.FLowerDivideCent').val(that.baseInfo.fLowerDivideCent)
      } else {
        console.log('setRate')
        var fRate = that.fRate
        var t1Debit = (that.pos.t1DebitCommission) / 100
        var t1DebitMax = (that.pos.t1DebitMaxFee) / 1000000
        var t1Credit = (that.pos.t1CreditCommission) / 100
        var t1OverSeas = (that.pos.t1OverSeasCommission) / 100
        var t1weixin = (that.scan.t1WeixinCommissionByMillion) / 10000
        var t1Alipay = (that.scan.t1AlipayCommissionByMillion) / 10000

        var t0Debit = (that.pos.t0DebitCommission) / 100
        var t0Credit = (that.pos.t0CreditCommission) / 100
        var t0OverSeas = (that.pos.t0OverSeasCommission) / 100
        var t0FixFee = (that.pos.t0FixFee) / 1000000
        var t0weixin = (that.scan.t0WeixinCommissionByMillion) / 10000
        var t0Alipay = (that.scan.t0AlipayCommissionByMillion) / 10000

        var t1UnionDebit = (that.unionpay.fT1DebitCommissionBymillion) / 100
        var t0UnionDebit = (that.unionpay.fT0DebitCommissionBymillion) / 100
        var t1UnionCredit = (that.unionpay.fT1CreditCommissionBymillion) / 100
        var t0UnionCredit = (that.unionpay.fT0CreditCommissionBymillion) / 100
        var t1UnionOverseas = (that.unionpay.fT1OverseasCommissionBymillion) / 100
        var t0UnionOverseas = (that.unionpay.fT0OverseasCommissionBymillion) / 100

        var t1UnionpayDebitMaxCharge = (that.unionpay.fT1DebitMaxFeeBymillion) / 1000000
        // var t1BelowUnionCreditRate=that.rounding(Number(t1UnionCredit*fRate));
        var t1BelowUnionCreditRate = (that.unionpay.fT1CreditCommissionBymillionLevel2) / 100
        var t0BelowUnionCreditRate = that.rounding(Number(t0UnionCredit * fRate))
        // var t1BelowUnionDebitRate = that.rounding(Number(t1UnionDebit*fRate));
        var t1BelowUnionDebitRate = (that.unionpay.fT1DebitCommissionBymillionLevel2) / 100
        var t0BelowUnionDebitRate = that.rounding(Number(t0UnionDebit * fRate))
        var t1BelowUnionOverseasRate = that.rounding(Number(t1UnionOverseas * 1))
        var t0BelowUnionOverseasRate = that.rounding(Number(t0UnionOverseas * 1))

        // var ut1DebitMaxFee = (that.unionpay.fT1DebitMaxFeeBymillion)/1000000;

        var scanLower = that.scan.lowerDivideCent
        var posLower = that.pos.lowerDivideCent
        var unionLower = that.unionpay.fLowerDivideCent

        this.$jquery('.t1DebitCommission').val(t1Debit)
        this.$jquery('.t1DebitMaxFee').val(t1DebitMax)
        this.$jquery('.t1CreditCommission').val(t1Credit)
        this.$jquery('.t1OverSeasCommission').val(t1OverSeas)
        this.$jquery('.t1WeixinCommission').val(t1weixin)
        this.$jquery('.t1AlipayCommission').val(t1Alipay)
        this.$jquery('.t0DebitCommission').val(t0Debit)
        this.$jquery('.t0CreditCommission').val(t0Credit)
        this.$jquery('.t0OverSeasCommission').val(t0OverSeas)
        this.$jquery('.t0FixFee').val(t0FixFee)
        this.$jquery('.t0WeixinCommission').val(t0weixin)
        this.$jquery('.t0AlipayCommission').val(t0Alipay)
        this.$jquery('.scanLowerDivideCent').val(scanLower)
        this.$jquery('.posLowerDivideCent').val(posLower)
        this.$jquery('.unionLowerDivideCent').val(unionLower)

        this.$jquery('.fT1DebitCommissionBymillion').val(t1UnionDebit)
        this.$jquery('.fT1CreditCommissionBymillion').val(t1UnionCredit)
        this.$jquery('.fT1OverseasCommissionBymillion').val(t1UnionOverseas)
        this.$jquery('.fT0DebitCommissionBymillion').val(t0UnionDebit)
        this.$jquery('.fT0CreditCommissionBymillion').val(t0UnionCredit)
        this.$jquery('.fT0OverseasCommissionBymillion').val(t0UnionOverseas)
        this.$jquery('.unionLowerDivideCent').val(unionLower)
        this.$jquery('.fT1UnionpayDebitMaxCharge').val(t1UnionpayDebitMaxCharge)

        this.$jquery('.fT1BelowDebitCommissionBymillion').val(t1BelowUnionDebitRate)
        this.$jquery('.fT0BelowDebitCommissionBymillion').val(t0BelowUnionDebitRate)
        this.$jquery('.fT1BelowCreditCommissionBymillion').val(t1BelowUnionCreditRate)
        this.$jquery('.fT0BelowCreditCommissionBymillion').val(t0BelowUnionCreditRate)

        this.$jquery('.fT1BelowOverseasCommissionBymillion').val(t1BelowUnionOverseasRate)
        this.$jquery('.fT0BelowOverseasCommissionBymillion').val(t0BelowUnionOverseasRate)

        if (that.scan.extraFeeRate) {
          that.extraFeeRate = that.$options.data().extraFeeRate
          const extraFeeRate = JSON.parse(that.scan.extraFeeRate)
          for (const item in that.extraFeeRate.alipay) {
            if (typeof (extraFeeRate.alipay[item]) === 'number') {
              this.$jquery('.' + 'alipay_' + item).val((extraFeeRate.alipay[item]) / 100)
            } else {
              this.$jquery('.' + 'alipay_' + item).val('')
            }
          }
          for (const item in that.extraFeeRate.wechat) {
            if (typeof (extraFeeRate.wechat[item]) === 'number') {
              this.$jquery('.' + 'wechat_' + item).val((extraFeeRate.wechat[item]) / 100)
            } else {
              this.$jquery('.' + 'wechat_' + item).val('')
            }
          }
        }
        // 日化
        that.rihuaEntity.wxCategoryDebitCommissionD1 = that.scan.wxCategoryDebitCommissionD1 / 100
        that.rihuaEntity.wxCategoryCreditCommissionD1 = that.scan.wxCategoryCreditCommissionD1 / 100
      }
    },
    rounding (n1) {
      return n1.toFixed(2)
    },
    getAgentLevel () {
      this.agentId = this.$store.getters.userId
      var con = JSON.parse(localStorage.levelConst)
      var compare = function (obj1, obj2) {
        var val1 = obj1.key
        var val2 = obj2.key
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
      this.agent_level_list = con.sort(compare)
    },

    setAgentLevel (item) {
      this.search_subAg.FAgentLevel = item
    },
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    /**
         * 新增/编辑模板费率table合并行方法
         */
    editTemplateTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === 'D+0单笔手续费') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    /**
         * 新增/编辑模板费率table合并行方法-扫码费率特殊处理
         */
    editTemplateTableSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 13,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === '类型') {
        if (rowIndex === 0) {
          return {
            rowspan: 8,
            colspan: 1
          }
        } else if (rowIndex === 8) {
          return {
            rowspan: 5,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    // this.getList();
    this.getBank()
    this.getPro()
    this.getAgentLevel()
    this.getUserInfo()
    this.getRow()
    // this.initRouters();
  },
  watch: {
    '$route' (to, from) {
      this.getList()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
   .demo-inline-form {
      margin-top: 18px;
    }
    .demo-form-inline {
        display: inline-block;
        float: right;
    }

    .btm-action {
        margin-top: 20px;
        text-align: center;
         .el-select {
          display: none;
          position: relative;
        }
    }

    .pagination {
        display: inline-block;
    }
    .list{
        padding-left: 16px;
    }
    .tab-tag{
      height:0;
      padding: 0;
      line-height: 0;
      background: transparent;
    }
    .dsn{
        display: none;
    }
    .submit{
      margin-left: 10px;
    }
    .check{
      margin-left: 2%;
    }
    /* 费率表单 */

     .posListTittle{
      width: 65%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      li{
        width: 15%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        //border-top: 1px solid #ccc;
        }
      li:last-child{ border-right: 0px solid #ccc;}
      li:first-child{ border-left: 1px solid #ccc;}
      input {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}

    }
    .posList{
      width: 65%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      //border-top: 1px solid #ccc;
     // border-bottom: 1px solid #ccc;
      li{
        width: 15%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        //border-top: 1px solid #ccc;
        }
      li:last-child{ border-right: 0px solid #ccc;}
      li:first-child{ border-left: 1px solid #ccc;}
      input {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}

    }
    .lastPosList{
      width: 65%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      //border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      li{
        width: 15%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        //border-top: 1px solid #ccc;
        }
      li:last-child{ border-right: 0px solid #ccc;}
      li:first-child{ border-left: 1px solid #ccc;}
      input {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}
    }

    .scanListTittle{
      width: 41%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      li{
        width: 24%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        //border-top: 1px solid #ccc;
        }
      li:last-child{ border-right: 0px solid #ccc;}
      li:first-child{ border-left: 1px solid #ccc;}
     // input {border: 0;width: 75%; text-align: center;}
    //  .el-input__inner {border: 0; text-align: center;}

    }
    .scanList{
      width: 41%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      //border-top: 1px solid #ccc;
      //border-bottom: 1px solid #ccc;
      li{
        width: 24%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        //border-bottom: 1px solid #ccc;
        }
      li:last-child{ border-right: 0px solid #ccc;border-bottom: 0px solid #ccc;}
      li:first-child{ border-left: 1px solid #ccc;}
      input:last-child {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}

    }
    .lastScanList{
       width: 41%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      //border-top: 1px solid #ccc;
       border-bottom: 1px solid #ccc;
      li{
        width: 24%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        //border-bottom: 1px solid #ccc;
        }
      li:last-child{ border-right: 0px solid #ccc;border-bottom: 0px solid #ccc;}
      li:first-child{ border-left: 1px solid #ccc;}
      input:last-child {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}
    }

     .unionMerListTittle{
      width: 75%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      //border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;

      li{
        width: 13%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;}
      li:last-child{ border-right: 0;}
      li:first-child{ border-left: 1px solid #ccc;}

    }
    .unionMerList{
      width: 75%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      border-left: 1px solid #ccc;
      //border-top: 1px solid #ccc;
      //border-bottom: 1px solid #ccc;

      li{
        width: 13%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;}
      li:last-child{ border-right: 0;}
      input {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}
    }
    .lastUnionMerList{
       width: 75%;
      padding-left: 0;
      list-style: none;
      line-height: 40px;
      margin-top: 0;
      margin-bottom: 0;
      border-right: 1px solid #ccc;
      border-left: 1px solid #ccc;
      //border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;

      li{
        width: 13%;
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;}
      li:last-child{ border-right: 0;}
      input {border: 0;width: 75%; text-align: center;}
      .el-input__inner {border: 0; text-align: center;}
    }
   .el-table input,.scanLowerDivideCent{
       position: relative;
       font-size: 14px;
       display: inline-block;
       width: calc(100% - 20px);
       text-align: center;
       background-color: #fff;
       background-image: none;
       border-radius: 4px;
       border: 1px solid #dcdfe6;
       -webkit-box-sizing: border-box;
       box-sizing: border-box;
       color: #606266;
       height: 40px;
       line-height: 40px;
       outline: 0;
       padding: 0 15px;
       +span{
           height: 30px;
           line-height: 30px;
           margin-left: 5px;
       }
       &:disabled{
           background-color: #F5F7FA;
           border-color: #E4E7ED;
           color: #C0C4CC;
           cursor: not-allowed;
       }

   }
   .el-input{
       span{
           line-height: 40px;
           color: #606266;
           font-size: inherit;
       }
   }
   h3 {
     margin:20px 0
   }
   .row {
    display: flex;
    .item {
      padding: 8px;
      width: 180px;
      box-sizing: content-box;
      text-align:center;
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
      &:first-child {
        border-left: 1px solid #EBEEF5;
      }
    }
  }
</style>
<style lang="scss">
    .agentMsgForm{
        .el-collapse-item__header{
            border-left: 1px solid #EBEEF5;
            border-right: 1px solid #EBEEF5;
            padding-left: 20px;
            line-height: 1;
            background: #F5F7FA;
            color: #909399;
        }
        .el-collapse-item__wrap{
            border-bottom: none;
        }
        .el-collapse-item__arrow {
            margin: 0 8px 0 10px;
        }
    }
</style>
